/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_YearInputs */

const en__field_year = /** @type {(inputs: _Field_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Year`)
};

const de__field_year = /** @type {(inputs: _Field_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jahr`)
};

/**
* | output |
* | --- |
* | "Year" |
*
* @param {_Field_YearInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_year = /** @type {((inputs?: _Field_YearInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_YearInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_year(inputs)
	return de__field_year(inputs)
});